export const jsonStringify = (
  ...params: Parameters<typeof JSON.stringify>
): string => {
  try {
    return JSON.stringify(...params);
  } catch {
    return "";
  }
};
